function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.61926 8.86914C7.20505 8.86914 6.86926 9.20493 6.86926 9.61914C6.86926 10.0334 7.20505 10.3691 7.61926 10.3691C8.03348 10.3691 8.36926 10.0334 8.36926 9.61914C8.36926 9.20493 8.03348 8.86914 7.61926 8.86914ZM5.86926 9.61914C5.86926 8.65264 6.65276 7.86914 7.61926 7.86914C8.58576 7.86914 9.36926 8.65264 9.36926 9.61914C9.36926 10.5856 8.58576 11.3691 7.61926 11.3691C6.65276 11.3691 5.86926 10.5856 5.86926 9.61914Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.0912 10.1464C7.28646 10.3417 7.28646 10.6583 7.0912 10.8536L2.72245 15.2223C2.52719 15.4176 2.21061 15.4176 2.01534 15.2223C1.82008 15.027 1.82008 14.7105 2.01534 14.5152L6.38409 10.1464C6.57936 9.95118 6.89594 9.95118 7.0912 10.1464Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.69325 3.90102C7.87686 3.83213 8.08379 3.87693 8.22246 4.0156L13.2225 9.0156C13.3611 9.15427 13.4059 9.3612 13.337 9.5448L11.9379 13.2738C11.878 13.4376 11.7759 13.5829 11.642 13.6948C11.5072 13.8075 11.345 13.8825 11.1718 13.912L11.1697 13.9124L2.45093 15.3624C2.29169 15.3889 2.12947 15.3368 2.01533 15.2227C1.90119 15.1085 1.84919 14.9463 1.87569 14.7871L3.32609 6.07212C3.35566 5.89975 3.42965 5.73807 3.54075 5.603C3.65185 5.46794 3.79623 5.36416 3.95966 5.30191L3.962 5.30102L7.69325 3.90102ZM4.31541 6.2365C4.31533 6.23653 4.31548 6.23646 4.31541 6.2365C4.31449 6.23689 4.31368 6.2375 4.31304 6.23827C4.3124 6.23905 4.31196 6.23996 4.31175 6.24094C4.31173 6.24102 4.31177 6.24086 4.31175 6.24094L2.97697 14.2612L11 12.9269L11.0007 12.9247L12.2876 9.495L7.74305 4.95041L4.31541 6.2365Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.48219 2.15376C9.60451 2.10255 9.7358 2.07617 9.86841 2.07617C10.001 2.07617 10.1323 2.10255 10.2546 2.15376C10.3763 2.20469 10.4866 2.27918 10.5793 2.37292L14.8646 6.65814C14.9583 6.75087 15.0328 6.86123 15.0837 6.98287C15.1349 7.10519 15.1613 7.23647 15.1613 7.36909C15.1613 7.5017 15.1349 7.63298 15.0837 7.7553C15.0328 7.87694 14.9583 7.9873 14.8646 8.08003L13.222 9.72264C13.0267 9.9179 12.7101 9.9179 12.5149 9.72264C12.3196 9.52738 12.3196 9.21079 12.5149 9.01553L14.1613 7.36908L14.1586 7.3664L9.8684 3.07618L9.86572 3.0789L8.22196 4.72264C8.0267 4.9179 7.71012 4.9179 7.51485 4.72264C7.31959 4.52738 7.31959 4.21079 7.51485 4.01553L9.15748 2.3729C9.25021 2.27917 9.36056 2.20469 9.48219 2.15376Z",
  fill: "black"
});

var SvgPenNib = function SvgPenNib(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPenNib, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PenNib.511645b8.svg";
export { ForwardRef as ReactComponent };